import { socket } from "../index";

const emitGetUsers = (
  roomId: string
) => {
  socket?.emit('GET_USERS', { roomId });
}

export default emitGetUsers;